import { ActionReducer } from '@ngrx/store';
import * as Sentry from '@sentry/angular';

/**
 * When a reducer throws, the store devtools (instrumented in production too) mark every
 * later action as "Interrupted by an error up the chain": the whole state stays frozen
 * until the page is reloaded and the user's next edits are silently dropped.
 * Report the error and keep the previous state instead, so only the faulty action is lost.
 */
export function reducerErrorGuard(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    try {
      return reducer(state, action);
    } catch (error) {
      console.error(`Reducer error on "${action?.type}"`, error);
      Sentry.captureException(error, {
        tags: { 'ngrx.action': action?.type },
        extra: { payload: scalarFields((action as any)?.payload) },
      });
      return state;
    }
  };
}

// Indexes and ids are enough to diagnose a failure; whole lots would bloat the event.
function scalarFields(payload: any) {
  if (!payload || typeof payload !== 'object') return undefined;
  return Object.fromEntries(Object.entries(payload).filter(([, value]) => value == null || typeof value !== 'object' && typeof value !== 'function'));
}
